import {useCallback,useEffect,useLayoutEffect,useState} from 'react';
import {setGameAudioEnabled,unlockGameAudio} from './gameAudio';

const key='tombala.x.gameSound';
export function useGameSound(member?:{enabled:boolean;save:(value:boolean)=>void}){
 const [localEnabled,setEnabled]=useState(()=>{if(member)return false;try{return localStorage.getItem(key)==='on';}catch{return false;}});
 const enabled=member?.enabled??localEnabled;
 // Apply the preference before any child playback effects, including a remount.
 useLayoutEffect(()=>{setGameAudioEnabled(enabled);},[enabled]);
 useEffect(()=>()=>setGameAudioEnabled(false),[]);
 useEffect(()=>{
  if(!enabled)return;
  // A reload keeps the preference, not necessarily the browser's permission.
  // Probe now so an idle sales screen can also offer the resume action.
  unlockGameAudio();
  const unlock=(event:Event)=>{if(!(event.target instanceof Element&&event.target.closest('[data-game-sound-control]')))unlockGameAudio();};
  // Click also covers touch activation; touch pointerdown may precede permission.
  window.addEventListener('click',unlock);window.addEventListener('keydown',unlock);
  return()=>{window.removeEventListener('click',unlock);window.removeEventListener('keydown',unlock);};
 },[enabled]);
 const change=useCallback((value:boolean)=>{
  // Persist the explicit choice before a refresh can interrupt React effects.
  if(member)member.save(value);
  else try{localStorage.setItem(key,value?'on':'off');}catch{/* Preview-only local preference. */}
  setGameAudioEnabled(value);if(value)unlockGameAudio();setEnabled(value);
 },[member?.save]);
 return [enabled,change] as const;
}
